export interface SkidDims {
	l: number;
	w: number;
	qty: number;
}

export interface SuncastData {
	customerId: string;
	vendorId: string;
	finishingStationId: string;
	orderedProductPriorityListItems: OrderedProductPriorityListItem[];
	productIdToSkidDims: Record<string, SkidDims>;
	/** Extra cart products; null dimensions mean truck packing is not configured yet. */
	shoppingCartOnlyProductIdToSkidDims?: Record<string, SkidDims | null>;
	productIdToFinishedUnitsPerDay: Record<string, number>;
	asMoldedInventoryProductIds: string[];
	productIdToBodiesPerMold: Record<string, number>;
}

export const DEFAULT_SUNCAST_DATA: SuncastData = {
	customerId: '',
	vendorId: '',
	finishingStationId: '',
	orderedProductPriorityListItems: [],
	productIdToSkidDims: {},
	shoppingCartOnlyProductIdToSkidDims: {
		'qiDqKPesHJvyECWM1JzH': { l: 44, w: 50, qty: 60 },
	},
	productIdToFinishedUnitsPerDay: {},
	asMoldedInventoryProductIds: [],
	productIdToBodiesPerMold: {},
}

/** Seed the requested cart product for configurations saved before this setting existed. */
export function getSuncastShoppingCartOnlyProductSkidDims(data: SuncastData): Record<string, SkidDims | null> {
	return { ...(data.shoppingCartOnlyProductIdToSkidDims ?? DEFAULT_SUNCAST_DATA.shoppingCartOnlyProductIdToSkidDims) };
}

export interface OrderedProductPriorityListItem {
	dueDate: Date | null,
	orderedProductId: string | null,
}
